<!-- 案例 -->
<template>
  <div class="el-trainingIndex" style="padding: 20px 20px 0;">
    <el-row class="content_block mb20">
      <TitleInfo title="案例名称" :titleImg="caozuo"></TitleInfo>
      <el-row class="p20">
        <el-row>
          <el-button :class="onIndex ==0?'check':''" plain @click="checkTask(0)">案例介绍</el-button>
          <el-button :class="onIndex ==1?'check':''" plain @click="checkTask(1)">任务1</el-button>
          <el-button :class="onIndex ==2?'check':''" plain @click="checkTask(2)">任务2</el-button>
          <el-button :class="onIndex ==3?'check':''" plain @click="checkTask(3)">任务3</el-button>
          <el-button :class="onIndex ==4?'check':''" plain @click="checkTask(4)">任务4</el-button>
          <el-button :class="onIndex ==5?'check':''" plain @click="checkTask(5)">任务5</el-button>
          <template v-if='examType == 2'>
            <span style="background-color: #EFF2F7;float: right;color: #2789E2;padding: 10px 30px;">合计得分：99分</span>
          </template>
        </el-row>
      </el-row>
      <template v-if="onIndex == 0">
        <el-row style="border: 1px solid #D3D3D3;margin: 0 20px 20px 20px;padding: 0 20px 20px 20px;min-height: calc(100vh - 280px);">
          <p class="fontB"><i class="el-icon-document-remove icon_"></i>案例名称：</p>
          <p>以开放督促改革、发展</p>
          <p class="fontB"><i class="el-icon-document icon_"></i>案例介绍：</p>
          <el-row class="aljj">
            <p>开放型经济新体制逐步健全体现在多个方面，如，坚持使市场在资源配置中起决定性作用和更好发挥政府作用，主动适应经济发展新常态，并与“- 带- -路”倡议和国家外交战略紧密衔接，积极探索对外经济合作新模式、新路径、新体制等。</p>
            <p>一是建立市场配置资源新机制。促进国际国内要素有序自由流动、资源全球高效配置、国际国内市场深度融合，建立公平开故、竞争有序的现代市场体系。</p>
            <p>二是形成经济运行管理新模式。按照国际化、法制化要求，依法管理开放，建立与国际高标准投资和贸易规则相适应的管理模式，形成参与国际宏观经济政策协调机制，推动国际经济治理结构不断完善。</p>
            <p>三是构建全方位开放新格局。继续实施“西部开放、东北振兴、中部崛起、东部率先”的区域总体战略，重点实施“一带- 路”倡议、京津冀协同发展战略和长江经济带战略，推动东西双向开放，促进技术设施互联互通，形成全方位开放新格局。</p>
            <p>四是打造国际合作竞争新优势。巩固和拓展传统优势，加快培育竞争新优势。以创新驱动为导向，以质量效益为核心，大力营造竞争有序的市场环境、透明高效的政务环境、公平正义的法制环境和合作共赢的人文环境，加速培育产业、区位、营商环境和规
            则标准等综合竞争优势，促进产业转型升级。</p>
            <p>同时，对外贸易实现跨越式发展，对外货物和服务贸易总额居世界前列，在国际经济下行压力较大的背景下，我国对世界经济的复苏作出了突出贡献;对外投资实现了历史性突破;外汇储备稳定，人民币国际化地位不断加强。人民币正式加入SDR货币篮子,
            标志着人民币国际地位持续提升,国际接受程度不断提高，我国人民币国际化进入新的发展阶段。
            以新的历史方位为坐标，推动形成全面开放新格局
            党的十九大报告指出，“中国特色社会主义进入了新时代，这是我国发展新的历史方位”。在这个战略性的新坐标下,要发展更高层次的开放型经济，推动形成全面开放新格局。
            新时代，坚持对外开放的基本国策，坚持打开国门搞建设，中国开放的大门不会关闭，只会越开越大。只有继续扩大开放，才能带来各种各样经济要素的交换，通过与世界各国的交流、合作、竞争，提升我国经济发展的质量、效益，提高全要素生产率，不断
            壮大我国经济实力和综合国力。这就要求必须进一步发展对外贸易， 积极有效利用外资，推动对外投资健康发展，实现商品、资本、技术。人员、服务、信息、数据等多维度要素与世界的有效交流与交换，推动中国迈向社会主义现代化强国。
            </p>
          </el-row>
        </el-row>
      </template>
      <Task1 v-if="onIndex == 1" :examType="examType"></Task1>
      <Task2 v-if="onIndex == 2" :examType="examType"></Task2>
      <Task3 v-if="onIndex == 3" :examType="examType"></Task3>
      <Task4 v-if="onIndex == 4" :examType="examType"></Task4>
      <Task5 v-if="onIndex == 5" :examType="examType"></Task5>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo";	//页面头部
import Task1 from "./components/PracticalTraining/Task1";	//任务1
import Task2 from "./components/PracticalTraining/Task2";	//任务2
import Task3 from "./components/PracticalTraining/Task3";	//任务3
import Task4 from "./components/PracticalTraining/Task4";	//任务4
import Task5 from "./components/PracticalTraining/Task5";	//任务5
export default {
  name: "TrainingIndex",
  components: {
  	TitleInfo,
  	Task1,
  	Task2,
  	Task3,
  	Task4,
  	Task5,
  },
  data() {
    return {
      caozuo:require("../../images/course/caozuo@2x.png"),
      onIndex:0,
      examType:this.$route.query.type
    };
  },
  created() {

  },
  mounted() {
    this.getInfo();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){

    },
    startExam(item){
      this.$router.push({name:'CoachExam',query:{type:1}});
    },
    resultDetails(item){ //查看错题
      this.$router.push({name:'CoachExam',query:{type:2}});
    },
    checkTask(index){ //切换任务
      this.onIndex = index;
    }
  }
};
</script>
 <style  lang="less">
  .el-trainingIndex{
    // min-height: calc(100vh - 120px);
    .content_block{
      min-height: calc(100vh - 140px);
      background-color: #ffffff;
      .el-divider--horizontal{
        margin: 0;
      }
    }
    .icon_{
      color: #2789E2;margin-right: 10px;
    }
    .check{
      color: #2789E2;
      border-color:#2789E2 ;
    }
    .aljj{
      p{
        margin: 0;
        line-height: 30px;
        // text-indent: 2em;
      }
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/Teacher/TrainingIndex.vue